module.exports = __webpack_public_path__ + "img/Group 4@2x.a5179fc9.png";